module.exports = __webpack_public_path__ + "static/media/icon-link.507f22de.svg";